export const companyInfo = {
  name: "Fix My AC",
  tagline: "Complete HVAC Solutions. From Homes to High-Rise Complexes.",
  subTagline: "End-to-end air conditioning & HVAC services — design, supply, installation, testing, commissioning & maintenance. Trusted by India's leading commercial & residential establishments.",
  ventureOf: "A Venture of J.M.D. Airconditioning Co. (INDIA)",
  phone: "+91-708-3496922",
  phoneDisplay: "+91-708-FIXMYAC",
  email: "info@fixmyac.net.in",
  supportEmail: "cs@fixmyac.net.in",
  whatsapp: "+917083496922",
  address: "New Delhi, India",
  logos: {
    main: "/fixmyac-full-logo.png",
    mascotHalf: "/fixmyac-mascot-half.png",
    mascotFull: "/fixmyac-mascot-full.png",
    jmd: "/jmd-logo.png",
  },
};

export const aboutData = {
  title: "About Fix My AC",
  subtitle: "Backed by Decades of HVAC Excellence",
  description: "Fix My AC is a venture of J.M.D. Airconditioning Co. (INDIA), bringing years of deep technical expertise in HVAC systems. We serve malls, retail outlets, commercial complexes, offices, hospitals, and residences across India with unmatched execution strength.",
  highlights: [
    { label: "Years of Experience", value: "40+" },
    { label: "Projects Completed", value: "2,500+" },
    { label: "Clients Served", value: "800+" },
    { label: "Cities Covered", value: "50+" },
  ],
  paragraphs: [
    "Our team combines technical qualification with hands-on execution capability, ensuring every project — from a single split AC installation to a full commercial HVAC system — is delivered on time, on budget, and to specification.",
    "We handle the complete lifecycle: Design → Supply → Installation → Testing → Commissioning → Maintenance."
  ],
};

export const servicesData = {
  residential: {
    title: "Residential & Basic Systems",
    description: "Comprehensive solutions for homes and small establishments",
    services: [
      { name: "Split AC Installation & Servicing", desc: "Professional installation and routine maintenance for all split AC brands" },
      { name: "Window AC Repair", desc: "Expert diagnostics and repair for window air conditioning units" },
      { name: "Tower AC Systems", desc: "Installation and servicing of tower/floor-standing AC systems" },
      { name: "Annual Maintenance Contracts (AMC)", desc: "Scheduled maintenance plans to keep your systems running efficiently" },
      { name: "Gas Charging & PCB Repair", desc: "Refrigerant recharging, PCB diagnostics, and circuit board repairs" },
      { name: "Compressor Diagnostics", desc: "Advanced compressor testing, repair, and replacement services" },
    ]
  },
  commercial: {
    title: "Commercial Systems",
    description: "Scalable HVAC solutions for businesses and commercial spaces",
    services: [
      { name: "Cassette AC Systems", desc: "Ceiling-mounted cassette units for offices and retail spaces" },
      { name: "Ductable AC Systems", desc: "Centralized duct-based cooling for large commercial areas" },
      { name: "VRF / VRV Systems", desc: "Variable Refrigerant Flow systems for multi-zone climate control" },
      { name: "Centralized Air-Conditioning", desc: "Complete central AC solutions for commercial buildings" },
      { name: "Air Distribution Systems", desc: "Engineered air distribution for optimal climate control" },
      { name: "Ventilation Systems", desc: "Fresh air ventilation and exhaust systems for healthy indoor air" },
    ]
  },
  advanced: {
    title: "Advanced & Large-Scale HVAC",
    description: "Enterprise-grade HVAC engineering for complex projects",
    services: [
      { name: "HVAC Design & Layout Planning", desc: "Complete system design with technical drawings and specifications" },
      { name: "Heat Load Calculations", desc: "Precise thermal load analysis for optimal system sizing" },
      { name: "SLD & Electrical Coordination", desc: "Single Line Diagrams and electrical integration planning" },
      { name: "Chilled Water Systems", desc: "Design and installation of chilled water piping networks" },
      { name: "AHU & FCU Systems", desc: "Air Handling Units and Fan Coil Units for centralized systems" },
      { name: "Copper Piping & Insulation", desc: "Professional piping networks with thermal insulation" },
      { name: "Duct Fabrication & Installation", desc: "Custom duct manufacturing and precision installation" },
      { name: "HVAC Execution for Malls & Complexes", desc: "Full-scale HVAC project execution for large commercial venues" },
    ]
  }
};

export const whyChooseUsData = [
  {
    title: "Technically Qualified Team",
    description: "Our engineers and technicians hold specialized HVAC certifications, ensuring every installation meets the highest technical standards."
  },
  {
    title: "Large Commercial Project Experience",
    description: "Proven track record in executing HVAC systems for malls, hospitals, and commercial complexes across India."
  },
  {
    title: "On-Time Execution",
    description: "We respect deadlines. Our project management ensures systematic execution with milestone-based delivery."
  },
  {
    title: "Transparent Pricing",
    description: "No hidden charges. Detailed quotations with clear breakdowns so you know exactly what you're paying for."
  },
  {
    title: "Strong After-Sales Support",
    description: "Dedicated service team for post-installation support, maintenance, and emergency repairs."
  },
  {
    title: "Backed by Established Company",
    description: "Part of J.M.D. Airconditioning Co. (INDIA) — a name synonymous with reliability in the HVAC industry."
  },
];

export const industriesData = [
  { name: "Malls", icon: "Building2" },
  { name: "Retail Outlets", icon: "Store" },
  { name: "Hospitals", icon: "Heart" },
  { name: "Offices", icon: "Briefcase" },
  { name: "Restaurants", icon: "UtensilsCrossed" },
  { name: "Commercial Complexes", icon: "Building" },
  { name: "Residential Apartments", icon: "Home" },
  { name: "Industrial Units", icon: "Factory" },
];

export const processSteps = [
  {
    step: 1,
    title: "Site Visit & Assessment",
    description: "Our technical team conducts a thorough site evaluation, understanding your requirements, space constraints, and environmental factors."
  },
  {
    step: 2,
    title: "Technical Planning",
    description: "Detailed HVAC design with heat load calculations, equipment selection, duct layouts, and electrical coordination tailored to your project."
  },
  {
    step: 3,
    title: "Installation & Execution",
    description: "Professional installation by certified technicians following industry standards with quality materials and systematic project management."
  },
  {
    step: 4,
    title: "Testing & Ongoing Support",
    description: "Comprehensive system testing, commissioning, and handover followed by dedicated maintenance and after-sales support."
  },
];

export const testimonialsData = [];

export const faqData = [
  {
    question: "What types of HVAC systems do you install?",
    answer: "We install the complete range — from residential split and window ACs to commercial ductable systems, VRF/VRV systems, cassette units, centralized air-conditioning, chilled water systems, AHU/FCU systems, and full-scale HVAC for malls and commercial complexes."
  },
  {
    question: "Do you provide Annual Maintenance Contracts (AMC)?",
    answer: "Yes, we offer comprehensive AMC plans covering periodic servicing, filter cleaning, gas checking, performance optimization, and emergency repair support. Our AMCs are available for both residential and commercial clients."
  },
  {
    question: "What areas in India do you serve?",
    answer: "We serve clients across India including Delhi NCR, Mumbai, Bangalore, Chennai, Hyderabad, Pune, Kolkata, Ahmedabad, Jaipur, and many more cities. For large commercial projects, we operate nationwide."
  },
  {
    question: "How quickly can you respond to a service request?",
    answer: "For AMC clients, we guarantee same-day or next-day service. For new service requests, our team typically responds within 24-48 hours depending on location and service type."
  },
  {
    question: "Do you handle HVAC design for new construction projects?",
    answer: "Absolutely. We offer end-to-end HVAC design services including heat load calculations, system design, SLD coordination, equipment selection, duct layouts, and complete execution for new construction and renovation projects."
  },
  {
    question: "What brands of AC equipment do you work with?",
    answer: "We are brand-agnostic and work with all major manufacturers including Daikin, Mitsubishi, Carrier, Trane, Blue Star, Voltas, Hitachi, LG, Samsung, and more. We recommend equipment based on your specific requirements and budget."
  },
];

export const serviceAreas = [
  "Delhi NCR", "Mumbai", "Bangalore", "Chennai", "Hyderabad",
  "Pune", "Kolkata", "Ahmedabad", "Jaipur", "Lucknow",
  "Chandigarh", "Noida", "Gurgaon", "Faridabad", "Ghaziabad"
];

export const images = {
  hero: "https://images.unsplash.com/photo-1760904730891-8a63cde68d3b",
  commercial: "https://images.pexels.com/photos/5463587/pexels-photo-5463587.jpeg",
  technician: "https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg",
  equipment: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg",
  modern: "https://images.pexels.com/photos/6471912/pexels-photo-6471912.jpeg",
  technicianDrill: "https://images.pexels.com/photos/5463587/pexels-photo-5463587.jpeg",
};
